module.exports = __webpack_public_path__ + "img/1-1-283x400.bb6a8e7b.jpg";